import { render, staticRenderFns } from "./BusinessSettingsComponent.vue?vue&type=template&id=b1c64506&"
import script from "./BusinessSettingsComponent.vue?vue&type=script&lang=ts&"
export * from "./BusinessSettingsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
